
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router'; 
import { SharedModule } from 'src/app/shared/shared.module';

import  {  PdfViewerModule  }  from  'ng2-pdf-viewer';
import { ConditionsGeneralComponent } from './conditions-general.component';
export const routes: Routes = [
  { path: '', component: ConditionsGeneralComponent, pathMatch: 'full' }
];


@NgModule({
  declarations: [ConditionsGeneralComponent],
  imports: [ NgxExtendedPdfViewerModule,
      PdfViewerModule,
      RouterModule.forChild(routes),
      CommonModule,
      SharedModule],
  providers: [],
  bootstrap: [ConditionsGeneralComponent],
})
export class ConditionGeneralModule {}